import CuotasAplazaloOH from "../components/agent/CuotasAplazaloOH";
import UbigeoSelector from "../components/ubigeo/ubigeo";


export const COMPONENTES_DISPONIBLES = {
 
    UbigeoSelector: UbigeoSelector,
    CuotasAplazaloOH:CuotasAplazaloOH,


};